

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { BocciaturaConsegnaFase1 } from "src/app/models/dto/bocciaturaFase1.model";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { ExcelService } from "src/app/services/excelService.service";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";
import * as Leaflet from "leaflet";
import { Pratica } from "src/app/models/pratica.model";

  

@Component({
    selector: "component-posizione-scuola",
    templateUrl: "./dialog-posizione-scuola.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class PosizioneScuola implements OnInit {

    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected praticaCompleta: Pratica;
      protected positionHasChanged:boolean = false;
      
      protected map!: Leaflet.Map;
      protected markers: Leaflet.Marker[] = [];
      protected options = {
        layers: [
          Leaflet.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution:
              '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          }),
        ],
        zoom: 17,
        center: { lat: 28.626137, lng: 79.821603 },
      };
    
    
    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig    
    ) {
      this.pratica          = this.config.data.pratica;
      this.praticaCompleta          = this.config.data.praticaCompleta;
     
    }
    ngOnInit() {
    }

    initMarkers() {
        const initialMarkers = [
          {
            position: {
              lat: this.pratica.coordinateScuola.latitude.valueOf(),
              lng: this.pratica.coordinateScuola.longitude.valueOf(),
            },
            draggable: false,
          },
        
        ];
        const dataScuola = initialMarkers[0];
        const markerScuola = this.generateMarker(dataScuola, 0, true);
        let popupScuola = "SCUOLA <b> "+ this.pratica.denominazione + "</b><br>" +
                          this.pratica.indirizzo + "<br>"+
                          "<b>" + this.pratica.comune + "</b><br>";
        
     
        markerScuola.addTo(this.map).bindPopup(popupScuola);
        this.markers.push(markerScuola);
    
        if(this.pratica.coordinateCentrale && this.pratica.coordinateCentrale!=null){
    
          initialMarkers.push(  {
            position: {
              lat: this.pratica.coordinateCentrale.latitude.valueOf(),
              lng: this.pratica.coordinateCentrale.longitude.valueOf(),
            },
            draggable: false,
          },);
          const dataCentrale = initialMarkers[1];
           const markerCentrale = this.generateMarker(dataCentrale, 0, false);
           let popupCentrale = "CENTRALE <b> "+ this.praticaCompleta.centrale.denominazione + "</b><br>" +
          this.praticaCompleta.centrale.indirizzo + "<br>"+
          "<b>" + this.praticaCompleta.centrale.comune.denominazione + "</b><br>"; 
          markerCentrale.addTo(this.map).bindPopup(popupCentrale);
          this.markers.push(markerCentrale);
        }
        
        this.map.panTo(dataScuola.position);
    
      }
    
      markerOver(event: any, index: number){
        const marker = event.target;
        marker.openPopup();
      }
      markerOut(event, index) {
        const marker = event.target;
        marker.closePopup();
      }
      generateMarker(data: any, index: number, isScuola:boolean) {
        let markerIconScuola = new Leaflet.Icon({
          iconUrl: '/assets/leaflet/images/marker-icon-bando2.png',
          //iconSize: [40, 25],
          iconSize: [25, 41],
        });
        let markerIconCentrale= new Leaflet.Icon({
          iconUrl: '/assets/leaflet/images/marker-icon-centrale.png',
        iconSize: [25, 41],
        });
        if(isScuola){
          return Leaflet.marker(data.position, { draggable: data.draggable, icon:markerIconScuola })
            //.on("click", (event) => this.markerClicked(event, index))
            .on("mouseover", (event) => this.markerOver(event, index))
            .on("mouseout", (event) => this.markerOut(event, index))
            .on("dragend", (event) => this.markerDragEnd(event, index));
        }else{
          return Leaflet.marker(data.position, { draggable: data.draggable, icon:markerIconCentrale })
         // .on("click", (event) => this.markerClicked(event, index))
          .on("mouseover", (event) => this.markerOver(event, index))
          .on("mouseout", (event) => this.markerOut(event, index))
          .on("dragend", (event) => this.markerDragEnd(event, index));
        }
        
      }
      markerClicked($event: any, index: number) {}
    
      markerDragEnd($event: any, index: number) {}
      onMapReady($event: Leaflet.Map) {
        this.map = $event;
        this.initMarkers();
      }
    
      mapClicked($event: any) {}

  }